module.exports = __webpack_public_path__ + "img/preview_amount.a1f986b1.png";